import request from "@/utils/request"; // 引入请求模块
// 发送验证码
export function sendCheckCodeByIdentity(data) {
  return request({
    url: "/user/sendCheckCodeByIdentity",
    method: "post",
    data: data
  });
}
// 登录
export function mobileLogin(data) {
  return request({
    url: "/user/mobileLogin",
    method: "post",
    data: data
  });
}
// 微信分享参数获取
export function getWechatShareParams(params) {
  return request({
    url: "/nodeCenter/getWechatShareParams",
    method: "get",
    params
  });
}